var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pint7x4reverse"},[_c('div',{staticClass:"label-content"},[_c('div',{staticClass:"name"},[_vm._v("お取り扱い上のご注意： ")]),_c('div',{staticClass:"content"},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.printData.desc)}})])])])
}
var staticRenderFns = []

export { render, staticRenderFns }